export default __webpack_public_path__ + "img/ba9dbd94e5ab48743e5e6ab437c3f60b.mp4";